class Helper {
  static PrintDate( str ){
    return new Date( str ).toLocaleDateString('de-DE')
  }
}

export default Helper;